import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, useMediaQuery, useTheme } from '@mui/material';

import MultiColorPicker from '~/components/atoms/color-picker/MultiColorPicker';
import Accordion from '~/components/ui/Accordion/Accordion';
import Select from '~/components/ui/Select';
import { FONTS, TABLET_MIN_WIDTH } from '~/constants/common';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { appsSlice } from '~/store/reducers/previewScreens/apps';
import { updateAppSiteThunk } from '~/store/reducers/previewScreens/apps';
import { getAppsReducer } from '~/store/reducers/previewScreens/apps/selectors';

const { actions } = appsSlice;

export function Appearance() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const { micrositeData, fonts, bacgkroundColor } = useSelector(getAppsReducer);

  const isMobile = useMediaQuery(theme.breakpoints.down(TABLET_MIN_WIDTH));

  const getReplacedInitialColor = () => {
    if (bacgkroundColor) return bacgkroundColor;
  };

  const handleChangeFont = (field, e) => {
    const value = e.target.value;

    dispatch(actions.setFonts({ field, value }));
    dispatch(
      updateAppSiteThunk({
        id: micrositeData?.id,
        body: {
          fonts: {
            ...fonts,
            [field]: value,
          },
        },
      }),
    );
  };

  return (
    <CreateQRContentBlockLayout type="appearance">
      <Accordion
        defaultExpanded
        variant="child"
        summary={t('basicTemplateLabels:tmplDesign')}
        details={
          <MultiColorPicker
            initialColors={[['#5356FF'], ['#7B1FA2'], ['#C62828'], ['#EF6C00'], ['#2E7D32']]}
            selectedTemplate={0}
            selectedColors={[micrositeData?.design?.primary]}
            blurFunction={(arr) => {
              if (micrositeData?.id) {
                dispatch(
                  updateAppSiteThunk({
                    id: micrositeData?.id,
                    body: {
                      design: {
                        primary: arr[0],
                      },
                    },
                  }),
                );
              }
            }}
            setColorValues={(data) => dispatch(actions.setBackgroundColor(data))}
            onSketchPickerChange={(val) => dispatch(actions.setBackgroundColor(val))}
            getReplacedInitialColor={getReplacedInitialColor}
          />
        }
      />
      <Accordion
        defaultExpanded
        variant="child"
        hideBottomBorder
        summary={t('basicTemplateLabels:tmplFonts')}
        details={
          <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} sx={{ gap: '16px' }}>
            <Select
              items={FONTS}
              onChange={(e) => handleChangeFont('title', e)}
              fullWidth
              sx={{ mr: 2 }}
              label={t('other:title')}
              defaultValue={fonts?.title || FONTS[3].value}
            />
            <Select
              items={FONTS}
              onChange={(e) => handleChangeFont('text', e)}
              fullWidth
              label={t('other:text')}
              defaultValue={fonts?.text || FONTS[3].value}
            />
          </Box>
        }
      />
    </CreateQRContentBlockLayout>
  );
}
